import { Page, Card, ResourceList, ResourceItem, Text, Select, BlockStack, InlineStack, Button, Toast } from '@shopify/polaris';
import { useEffect, useState } from 'react';
import { listProducts, listForms, assignFormToProduct } from '../lib/api';

export default function Products() {
  const [products, setProducts] = useState([]);
  const [forms, setForms]       = useState([]);
  const [loading, setLoading]   = useState(true);
  const [toast, setToast]       = useState(null);
  const [pageInfo, setPageInfo] = useState({ hasNextPage: false, endCursor: null });

  async function load(after = null) {
    setLoading(true);
    const [p, f] = await Promise.all([listProducts(after), after ? Promise.resolve(forms) : listForms()]);
    setProducts(after ? [...products, ...p.nodes] : p.nodes);
    setPageInfo(p.pageInfo);
    if (!after) setForms(f);
    setLoading(false);
  }
  useEffect(() => { load(); }, []);

  async function assign(productId, formId) {
    await assignFormToProduct(productId, formId);
    setProducts(products.map((p) => p.id === productId ? { ...p, formMeta: { value: formId } } : p));
    setToast('Form atandı');
  }

  const formOptions = [{ label: '— Form yok —', value: '' }, ...forms.map((f) => ({ label: f.title, value: f.id }))];

  return (
    <Page title="Ürünlere Form Ata">
      <Card>
        <ResourceList
          loading={loading}
          items={products}
          renderItem={(product) => (
            <ResourceItem id={product.id} accessibilityLabel={product.title}>
              <InlineStack align="space-between" blockAlign="center" gap="400">
                <BlockStack gap="100">
                  <Text variant="bodyMd" fontWeight="semibold">{product.title}</Text>
                  <Text variant="bodySm" tone="subdued">{product.handle}</Text>
                </BlockStack>
                <div style={{ minWidth: 280 }}>
                  <Select
                    label=""
                    labelHidden
                    value={product.formMeta?.value || ''}
                    options={formOptions}
                    onChange={(v) => assign(product.id, v)}
                  />
                </div>
              </InlineStack>
            </ResourceItem>
          )}
        />
        {pageInfo.hasNextPage && (
          <InlineStack align="center"><Button onClick={() => load(pageInfo.endCursor)}>Daha fazla</Button></InlineStack>
        )}
      </Card>
      {toast && <Toast content={toast} onDismiss={() => setToast(null)} duration={1800} />}
    </Page>
  );
}
